import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import style from './CampaignCard.less'

function status(campaign) {
    if (campaign.finished) return 'closed'
    if (campaign.started) return 'opened'
    return null
}

class CampaignCard extends Component {
    static propTypes = {
        campaign: PropTypes.object.isRequired
    }

    render() {
        const {campaign, ...others} = this.props

        const header = (
            <h5>{i18n.campaign}</h5>
        )

        const campaignStatus = status(campaign)

        return (
            <div className={style.default}>
                <Card justified
                    kind='tab'
                    header={header}
                    {...others}>
                    <div className={style.title}>
                        {campaignStatus && (
                            <Icon icon={campaignStatus} size='sm' />
                        )}
                        <h5>> {campaign.title}</h5>
                    </div>
                </Card>
            </div>
        )
    }
}

export default CampaignCard


// WEBPACK FOOTER //
// ./lib/satisfaction/components/CampaignCard.js